import Navigation from "@/components/Navigation";
import { ConsultationForm } from "@/components/ConsultationForm";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

const RedLightLaser = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <div className="pt-24 pb-12 px-6 max-w-7xl mx-auto">
        <h1 className="text-4xl font-serif mb-8">Red Light Laser Therapy</h1>
        <p className="mb-6 text-lg">
          Red light laser therapy is a non-invasive treatment that uses specific wavelengths
          of light to stimulate cellular repair and regeneration.
        </p>
        <Dialog>
          <DialogTrigger className="bg-primary text-white px-6 py-3 rounded-full hover:bg-primary/90 transition-colors">
            Schedule Consultation
          </DialogTrigger>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Schedule a Consultation</DialogTitle>
            </DialogHeader>
            <ConsultationForm />
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
};

export default RedLightLaser;